import { AsyncStore } from "~/store/async-store"
import { initial } from "~/store/async-store.utils"
import type { Registry } from "./registry.model"

type Err = string
type Ok = {
  registries: Registry[]
}

export class RegistriesStore extends AsyncStore<Err, Ok> {
  constructor() {
    super("RegistriesStore", initial)
  }
}
